/* ═══════════════════════════════════════════════════════════════
   Order progress

   Reads the running subtotal off the qop:change event the pad
   dispatches on every recalculation, and reports how far the order
   is from the next threshold: free shipping first, then each bulk
   tier in turn.

   Deliberately a separate module rather than more logic inside the
   pad: it only listens, holds no state of the order, and can be
   removed by deleting the markup without touching the pad at all.

   Every threshold and every line of copy comes from a section
   setting. Nothing is inferred, so the pad cannot promise a discount
   the store is not configured to give — the tiers here have to be
   set up as automatic discounts in the admin to be real.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function parseTiers(root) {
    var raw = root.getAttribute('data-tiers') || '[]';
    try {
      var tiers = JSON.parse(raw);
      return tiers
        .filter(function (t) {
          return t && t.cents > 0;
        })
        .sort(function (a, b) {
          return a.cents - b.cents;
        });
    } catch (err) {
      if (window.console && console.warn) console.warn('[medicore] bad tier data', err);
      return [];
    }
  }

  /* Money is formatted from the shop's own format string so the pad
     and this strip never disagree about currency or separators. */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCents = parts.join('.');
    var noCents = parts[0];

    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, withCents)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noCents)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCents.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noCents.replace(/,/g, ' '));
  }

  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (whole, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : whole;
    });
  }

  function Progress(root) {
    var tiers = parseTiers(root);
    if (!tiers.length) return;

    var format = root.getAttribute('data-money-format') || '${{amount}}';
    var messageTemplate = root.getAttribute('data-message') || '';
    var textEl = root.querySelector('[data-qop-progress-text]');
    var nextEl = root.querySelector('[data-qop-progress-next]');
    var barEl = root.querySelector('[data-qop-progress-bar]');
    var ticksEl = root.querySelector('[data-qop-progress-ticks]');

    /* Ticks are drawn once — the labels never change, only which of
       them count as met. */
    if (ticksEl) {
      tiers.forEach(function (tier) {
        var li = document.createElement('li');
        li.className = 'qop-progress__tick';
        li.textContent = money(tier.cents, format) + ' · ' + tier.reward;
        li.setAttribute('data-cents', tier.cents);
        ticksEl.appendChild(li);
      });
    }

    function render(cents) {
      root.hidden = cents <= 0;
      if (cents <= 0) return;

      var top = tiers[tiers.length - 1];
      var next = null;
      var reached = null;

      tiers.forEach(function (tier) {
        if (cents >= tier.cents) reached = tier;
        else if (!next) next = tier;
      });

      if (next) {
        var short = next.cents - cents;
        if (textEl) {
          textEl.classList.remove('qop-progress__text--met');
          textEl.innerHTML = fill(messageTemplate, {
            amount: '<strong>' + money(short, format) + '</strong>',
            reward: '<strong>' + next.reward + '</strong>'
          });
        }
        if (nextEl) nextEl.textContent = money(cents, format) + ' / ' + money(next.cents, format);
        if (barEl) {
          barEl.classList.remove('qop-progress__bar--met');
          barEl.style.width = Math.min(100, (cents / next.cents) * 100) + '%';
        }
      } else {
        /* Past the top tier — report what has been earned rather than
           leaving the strip pointing at a threshold already cleared. */
        if (textEl) {
          textEl.classList.add('qop-progress__text--met');
          textEl.innerHTML = fill(root.getAttribute('data-met-message') || '', {
            reward: '<strong>' + (reached ? reached.reward : top.reward) + '</strong>'
          });
        }
        if (nextEl) nextEl.textContent = money(cents, format);
        if (barEl) {
          barEl.classList.add('qop-progress__bar--met');
          barEl.style.width = '100%';
        }
      }

      if (ticksEl) {
        Array.prototype.forEach.call(ticksEl.children, function (li) {
          li.classList.toggle('is-met', cents >= parseInt(li.getAttribute('data-cents'), 10));
        });
      }
    }

    document.addEventListener('qop:change', function (event) {
      render((event.detail && event.detail.cents) || 0);
    });

    render(0);
  }

  function init() {
    document.querySelectorAll('[data-qop-progress]').forEach(function (root) {
      if (root.__qopProgressReady) return;
      root.__qopProgressReady = true;
      Progress(root);
    });
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
